const indexItems = [
  { label: '热播电视剧', desc: '国剧、港剧、韩剧、美剧全收录', icon: 'ri-tv-line', color: 'primary' },
  { label: '高分电影', desc: '院线大片、经典老片、独立佳作', icon: 'ri-film-line', color: 'accent' },
  { label: '热门综艺', desc: '音乐竞演、真人秀、脱口秀', icon: 'ri-music-line', color: 'secondary' },
  { label: '动漫番剧', desc: '日漫、国漫、剧场版全收录', icon: 'ri-ghost-line', color: 'primary' },
  { label: '纪录片', desc: '自然、历史、科技、人文精选', icon: 'ri-earth-line', color: 'accent' },
  { label: '少儿内容', desc: '安全健康的儿童动画与教育', icon: 'ri-heart-line', color: 'secondary' },
  { label: '4K专区', desc: '超清画质沉浸式观影享受', icon: 'ri-4k-line', color: 'primary' },
  { label: '最新上线', desc: '同步更新最快最新影视资源', icon: 'ri-rocket-line', color: 'accent' },
];

const colorMap: Record<string, { bg: string; iconBg: string; iconColor: string; hoverBorder: string }> = {
  primary: { bg: 'bg-primary-50', iconBg: 'bg-primary-100', iconColor: 'text-primary-500', hoverBorder: 'hover:border-primary-200' },
  accent: { bg: 'bg-accent-50', iconBg: 'bg-accent-100', iconColor: 'text-accent-600', hoverBorder: 'hover:border-accent-200' },
  secondary: { bg: 'bg-secondary-50', iconBg: 'bg-secondary-100', iconColor: 'text-secondary-600', hoverBorder: 'hover:border-secondary-300' },
};

export default function IndexSection() {
  return (
    <section id="index" className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-100">
      <div className="max-w-[1200px] mx-auto">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-2">分类索引</h2>
          <p className="text-sm text-foreground-500">按内容类型快速找到你想看的</p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4">
          {indexItems.map((item) => {
            const c = colorMap[item.color];
            return (
              <div
                key={item.label}
                className={`rounded-xl p-5 border border-background-200/70 ${c.hoverBorder} transition-all duration-200 cursor-pointer bg-background-50 hover:${c.bg}`}
              >
                <div className={`w-10 h-10 rounded-xl ${c.iconBg} flex items-center justify-center mb-3`}>
                  <i className={`${item.icon} ${c.iconColor} text-lg`}></i>
                </div>
                <h3 className="text-sm font-semibold text-foreground-900 mb-1">{item.label}</h3>
                <p className="text-xs text-foreground-500">{item.desc}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}